import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, RadioGroup, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { DL_CASE_TYPE_OPTIONS, isDlCaseType } from '../../constants/driver';
import { contentKeys } from '../../constants/contentKeys';

const DriverCaseTypeStep: React.FC = () => {
  const question = "Hvilken type kørekortansøgning vil du gennemføre?";
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_case_type).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handleSelect = (value: string) => {
    if (isDlCaseType(value)) {
      updateSelfServiceData('dlCaseType', value);
    }
  };

  const handleNext = () => {
    if (selfServiceData.dlCaseType) {
      goNext();
    }
  };

  return (
    <StepContainer title={question}>
      {body && <InfoBox type="info">{body.map((p, i) => <p key={i}>{p}</p>)}</InfoBox>}
      <RadioGroup
        name="dlCaseType"
        options={DL_CASE_TYPE_OPTIONS}
        value={selfServiceData.dlCaseType}
        onChange={handleSelect}
        legend={question}
        required
      />
      <NavigationButtons onBack={goBack} onNext={handleNext} nextDisabled={!selfServiceData.dlCaseType} />
    </StepContainer>
  );
};

export default DriverCaseTypeStep;
